import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "grid grid-cols-2 auto-rows-auto grid-flow-row-dense gap-x-4 gap-y-8" };
const _hoisted_3 = { class: "form-element" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("label", null, "Digital vendor name", -1);
const _hoisted_5 = { class: "form-element" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", null, "Type", -1);
const _hoisted_7 = { class: "form-element-full" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", { class: "uppercase" }, "url", -1);
const _hoisted_9 = { class: "form-element-full" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("label", null, "Organization", -1);
const _hoisted_11 = { class: "form-element" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("label", null, "Client ID", -1);
const _hoisted_13 = { class: "form-element" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("label", null, "Client secret", -1);
const _hoisted_15 = { class: "form-element" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("label", null, "Username", -1);
const _hoisted_17 = { class: "form-element" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("label", null, "Password", -1);
const _hoisted_19 = { class: "form-element" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createElementVNode("span", { class: "uppercase" }, "api"),
    /*#__PURE__*/ _createTextVNode(" key")
], -1);
const _hoisted_21 = { class: "form-element" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("label", null, "Swap key", -1);
const _hoisted_23 = { class: "flex flex-row gap-2 col-span-2" };
import { ref, watch } from 'vue';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Dropdown from 'primevue/dropdown';
import Button from 'primevue/button';
import InlineMessage from 'primevue/inlinemessage';
import ProgressSpinner from 'primevue/progressspinner';
import { useDigitalVendorEndpoint } from '../composables/useDigitalVendorEndpoint';
import { DigitalVendorEndpointStore as store } from '../stores/DigitalVendorEndpointStore';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DigitalVendorEndpointForm',
    setup(__props) {
        const { saveOrUpdateModel } = useDigitalVendorEndpoint();
        const canSubmit = ref(false);
        const isLoading = ref(false);
        const hasError = ref(false);
        const submitSuccess = ref(false);
        const isEditingExisting = ref(false);
        const vendor = ref(store.getVendorByActiveEndpoint());
        const submitText = ref('');
        const successText = ref(store.activeEndpoint.id ? 'updated' : 'created');
        const errorText = ref('');
        const dropdownPlaceholder = ref(store.activeEndpoint.type ?? 'Select type');
        watch([
            () => store.activeEndpoint.id,
            () => store.activeEndpoint.type,
            () => store.activeEndpoint.base_url,
            () => store.activeEndpoint.digital_vendor_id,
        ], ([id, type, base_url, digital_vendor_id]) => {
            canSubmit.value = !!type && !!base_url && !!digital_vendor_id;
            isEditingExisting.value = !!id;
            submitText.value = id ? 'Update' : 'Create';
            errorText.value = id ? 'updating' : 'creating';
        }, { immediate: true });
        const handleSubmit = async () => {
            isLoading.value = true;
            const result = await saveOrUpdateModel(store.activeEndpoint);
            if (result) {
                if (isEditingExisting.value) {
                    store.updateEndpoint(result);
                }
                else {
                    store.addEndpointToList(result);
                }
                store.setActiveEndpoint(result);
                isLoading.value = false;
                hasError.value = false;
                submitSuccess.value = true;
                setTimeout(() => {
                    submitSuccess.value = false;
                    successText.value = 'updated';
                }, 3000);
            }
            else {
                hasError.value = true;
                isLoading.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (_unref(store).activeEndpoint)
                ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createVNode(_unref(InputText), {
                                modelValue: vendor.value.display_name,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((vendor.value.display_name) = $event)),
                                disabled: ""
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createVNode(_unref(Dropdown), {
                                modelValue: _unref(store).activeEndpoint.type,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(store).activeEndpoint.type) = $event)),
                                options: _unref(store).validEndpointTypes,
                                "option-label": "name",
                                "option-value": "value",
                                placeholder: dropdownPlaceholder.value,
                                class: "w-full"
                            }, null, 8, ["modelValue", "options", "placeholder"])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _hoisted_8,
                            _createVNode(_unref(InputText), {
                                modelValue: _unref(store).activeEndpoint.base_url,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(store).activeEndpoint.base_url) = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _hoisted_10,
                            _createVNode(_unref(InputText), {
                                modelValue: _unref(store).activeEndpoint.organization,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(store).activeEndpoint.organization) = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createVNode(_unref(InputText), {
                                modelValue: _unref(store).activeEndpoint.client_id,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(store).activeEndpoint.client_id) = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createVNode(_unref(Password), {
                                modelValue: _unref(store).activeEndpoint.client_secret,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(store).activeEndpoint.client_secret) = $event)),
                                "input-class": "w-full",
                                feedback: false,
                                "toggle-mask": ""
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createVNode(_unref(InputText), {
                                modelValue: _unref(store).activeEndpoint.username,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(store).activeEndpoint.username) = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            _hoisted_18,
                            _createVNode(_unref(Password), {
                                modelValue: _unref(store).activeEndpoint.password,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(store).activeEndpoint.password) = $event)),
                                "input-class": "w-full",
                                feedback: false,
                                "toggle-mask": ""
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createVNode(_unref(InputText), {
                                modelValue: _unref(store).activeEndpoint.api_key,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(store).activeEndpoint.api_key) = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                            _hoisted_22,
                            _createVNode(_unref(InputText), {
                                modelValue: _unref(store).activeEndpoint.swap_key,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(store).activeEndpoint.swap_key) = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", null, [
                                _createVNode(_unref(Button), {
                                    disabled: !canSubmit.value,
                                    style: { "max-height": "50px" },
                                    onClick: _cache[10] || (_cache[10] = ($event) => (handleSubmit()))
                                }, {
                                    default: _withCtx(() => [
                                        (!isLoading.value)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(_toDisplayString(submitText.value), 1)
                                            ], 64))
                                            : (_openBlock(), _createBlock(_unref(ProgressSpinner), {
                                                key: 1,
                                                style: { "width": "40px", "height": "40px" },
                                                "stroke-width": "2",
                                                "animation-duration": ".5s",
                                                pt: {
                                                    circle: {
                                                        style: {
                                                            stroke: '#FFFFFF !important'
                                                        }
                                                    }
                                                }
                                            }))
                                    ]),
                                    _: 1
                                }, 8, ["disabled"])
                            ]),
                            (submitSuccess.value)
                                ? (_openBlock(), _createBlock(_unref(InlineMessage), {
                                    key: 0,
                                    severity: "success"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(" Endpoint successfully " + _toDisplayString(successText.value), 1)
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            (hasError.value)
                                ? (_openBlock(), _createBlock(_unref(InlineMessage), {
                                    key: 1,
                                    severity: "error"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(" Error " + _toDisplayString(errorText.value) + " endpoint ", 1)
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
